import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '';

export function isEmailJsConfigured() {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    return false;
  }
  return !SERVICE_ID.includes('YOUR_') && !TEMPLATE_ID.includes('YOUR_') && !PUBLIC_KEY.includes('YOUR_');
}

export function getEmailJsConfigError() {
  return 'EmailJS is not configured yet. Please set REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, and REACT_APP_EMAILJS_PUBLIC_KEY.';
}

export async function sendInquiryEmail({ name, email, phone, details }) {
  if (!isEmailJsConfigured()) {
    throw new Error(getEmailJsConfigError());
  }

  const templateParams = {
    name: name,
    email: email,
    phone: phone,
    details: details
 };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
}
